import React from 'react';
import properties from '../../constants/Properties';
import locales from '../../locales/LocalesManager';
import { showCroppingMenu } from '../../actions/MenuActions';
import { updateCurrentSlideThumbnail, updateCroppingHospot, selectShape, updateShapeRotation } from '../../actions/CurrentSlideActions';
import mouseUtils from '../../components/utils/MouseUtils';
import zoomUtils from '../../components/utils/ZoomUtils';
import { updateCurrentSlide } from '../../actions/ProductionActions';
import storeManager from '../../store/StoreManager';
import { connect } from 'react-redux';
import saveManager from '../utils/SaveManager';
import apiServiceUtils from '../utils/ApiServiceUtils';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import platformDetection from '../utils/PlatformDetection';
import {MenuInput} from './SizeAndPositionButtons';

const Title = React.createClass({
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        const titleStyle = {
            position: 'absolute',
            backgroundColor: properties.BROWSER_SELECTED_COLOR,
            width: this.props.accordionWidth,
            height: properties.CLIPART_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: 20,
            top: 0
        };

        const spanStyle = {
            color: 'white',
            fontSize: 16,
            cursor: 'default',
            position: 'absolute',
            top: 6
        };

        return (
            <div style={titleStyle}>
                <span style={spanStyle}>{locales.getCaption('CroppingMenuTitle')}</span>
            </div>
        );
    }
});

const Button = React.createClass({
    getInitialState () {
        return {
            isOver: false
        };
    },
    onMouseIn () {
        this.setState({
            isOver: true
        });
    },
    onMouseOut () {
        this.setState({
            isOver: false
        });
    },
    onClick (e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        setTimeout(function() {
            zoomUtils.updateCroppingInitialPosition = true;
        }.bind(this), 200);

        if (!zoomUtils.croppingTarget) {
            zoomUtils.croppingTargetRotation = 0;
            this.props.dispatch(showCroppingMenu(false));
            return;
        }

        switch (this.props.index) {
            case 0: { // CROPPING ELEMENT
                setTimeout(function() {
                    this.props.dispatch(updateCroppingHospot(zoomUtils.croppingTarget.uuid, zoomUtils.currentCroppingHotspot));
                    audioEditorUtils.addActionToHistory();
                    this.props.dispatch(updateCurrentSlide());
                    this.props.dispatch(updateCurrentSlideThumbnail(true));
                    this.props.dispatch(showCroppingMenu(false));
                    saveManager.isContentChanged(true);
                }.bind(this), 10);
                break;
            }

            case 1: { // RESET CROPPING
                if (this.isResetEnabled() == true) {
                    saveManager.isContentChanged(true);
                    this.props.dispatch(updateCroppingHospot(zoomUtils.croppingTarget.uuid, ''));
                    audioEditorUtils.addActionToHistory();
                    this.props.dispatch(updateCurrentSlide());
                    this.props.dispatch(updateCurrentSlideThumbnail(true));
                    this.props.dispatch(showCroppingMenu(false));
                    zoomUtils.currentCroppingHotspot = undefined;
                }
                break;
            }

            case 2: { // CANCEL
                this.props.dispatch(updateCurrentSlide());
                this.props.dispatch(updateCurrentSlideThumbnail(true));
                this.props.dispatch(selectShape(''));
                this.props.dispatch(showCroppingMenu(false));
                break;
            }
        }

        if (zoomUtils.croppingTargetRotation != 0) {
            this.props.dispatch(updateShapeRotation(zoomUtils.croppingTarget.uuid, zoomUtils.croppingTargetRotation));
            zoomUtils.croppingTargetRotation = 0;
        }
    },
    isResetEnabled() {
        if (this.props.index != 1)
            return false;

        const shapeModel = zoomUtils.croppingTarget;

        if (shapeModel && shapeModel.hotSpot != undefined && shapeModel.hotSpot != '')
            return true;
        else
            return false;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.state.isOver != nextState.isOver || this.props.accordionWidth != newProps.accordionWidth)
            return true;
        else
            return false;
    },
    render() {
        var iconColor;
        var buttonColor;
        var tabIndexValue;

        if (this.props.index == 0) {
            if (this.state.isOver == true) {
                iconColor = properties.CONTEXT_HOVER_COLOR;
                buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
            } else {
                iconColor = 'black';
                buttonColor = '#48A5E5';
            }
        } else
        if (this.props.index == 1 && this.isResetEnabled() == false) {
            iconColor = '#CFCFCF';
            buttonColor = '#EEEEEE';
            tabIndexValue = '-1';
        } else {
            if (this.state.isOver == true) {
                iconColor = properties.CONTEXT_HOVER_COLOR;
                buttonColor = properties.SLIDE_MENU_HOVER_COLOR;
            } else {
                iconColor = 'black';
                buttonColor = '#DCDCDC';
            }
        }

        var topPosition =  5 + this.props.index * (properties.OBJECT_ADVANCED_BUTTON_HEIGHT + 5);

        const buttonStyle = {
            position: 'absolute',
            backgroundColor: buttonColor,
            width: this.props.accordionWidth - properties.BROWSER_LEFT_PADDING,
            height: properties.OBJECT_ADVANCED_BUTTON_HEIGHT,
            display: 'flex',
            alignItems: 'center',
            paddingLeft: properties.BROWSER_LEFT_PADDING,
            top: topPosition,
            color: 'white',
            paddingTop: 0,
            paddingBottom: 0,
            paddingRight: 0,
            boxSizing: 'initial',
            fontSize: 'initial',
            borderStyle: 'none'
        };

        const spanStyle = {
            color: iconColor,
            cursor: 'default',
            fontSize: 18,
            textAlign: 'center',
            width: buttonStyle.width,
            top: 0
        };

        var buttonId;

        if (this.props.index == 0)
            buttonId = 'croppingMenuFirstFocusableElement';

        if (this.props.index == 2)
            buttonId = 'croppingMenuLastFocusableElement';

        return (
            <button id={buttonId} aria-label={this.props.text} tabIndex={tabIndexValue} aria-disabled={tabIndexValue == '-1' ? true : false} style={buttonStyle} onTouchEnd={this.onClick} onClick={this.onClick} onMouseOver={this.onMouseIn} onMouseOut={this.onMouseOut}>
                <span style={spanStyle}>{this.props.text}</span>
            </button>
        );
    }
});

const CroppingMenuContent = React.createClass({
    getInitialState () {
        return {
            currentAlert: 'none'
        };
    },
    componentWillReceiveProps(nextProps) {
        if (this.props.refreshShapePosition != nextProps.refreshShapePosition) {
            this.forceUpdate();
            return;
        }

        if (platformDetection.isIOS())
            return;

        setTimeout(function() {
            var element = document.getElementById('croppingMenuFirstFocusableElement');

            if (element)
                element.focus();
        }.bind(this), 30);
    },
    getHotSpot() {
        const shapeModel = this.getContextTarget();

        if (!shapeModel)
            return {};

        if (zoomUtils.currentCroppingHotspot && zoomUtils.currentCroppingHotspot.x1 >= 0)
            return zoomUtils.currentCroppingHotspot;

        if(shapeModel.hotSpot){
            return {
                x1: shapeModel.hotSpot.x1,
                x2: shapeModel.hotSpot.x2,
                y1: shapeModel.hotSpot.y1,
                y2: shapeModel.hotSpot.y2
            };
        } else {
            return {
                x1: 0,
                x2: 100,
                y1: 0,
                y2: 100
            };
        }
    },
    getContextTarget() {
        const shapes = storeManager.getState().currentSlide.model.content;

        for (let i = 1; i < shapes.length; i++) {
            if (shapes[i].uuid === zoomUtils.croppingTarget.uuid)
                return shapes[i];
        }

        return zoomUtils.croppingTarget;
    },
    changeCrop(property, value) {
        if (zoomUtils.updateCurrentCroppingHotspot) {
            value = parseInt(value);
            const absoluteValue = Math.abs(value) || 0;
            zoomUtils.updateCurrentCroppingHotspot(property, absoluteValue);
        }
    },
    onFocusHandler(property) {
        this.setState({
            currentAlert: property
        });
    },
    onBlurHandler(property) {
        this.checkCorrectValue(property);

        this.setState({
            currentAlert: 'none'
        });
    },
    checkCorrectValue(property) {
        const minSize = 30;
        var realShape = this.getRealShapeSize(zoomUtils.croppingTarget);
        var localHotSpot = {x1: zoomUtils.currentCroppingHotspot.x1, x2: zoomUtils.currentCroppingHotspot.x2, y1: zoomUtils.currentCroppingHotspot.y1, y2: zoomUtils.currentCroppingHotspot.y2};
        var xMinLimitPercents = Math.ceil(minSize * 100 / realShape.width);
        var yMinLimitPercents = Math.ceil(minSize * 100 / realShape.height);

        switch (property) {
            case 'x1': {
                if (localHotSpot.x1 + xMinLimitPercents > localHotSpot.x2)
                    localHotSpot.x1 = localHotSpot.x2 - xMinLimitPercents;
                break;
            }
            case 'x2': {
                if (localHotSpot.x2 > 100)
                    localHotSpot.x2 = 100;

                if (localHotSpot.x2 - xMinLimitPercents < localHotSpot.x1)
                    localHotSpot.x2 = localHotSpot.x1 + xMinLimitPercents;
                break;
            }
            case 'y1': {
                if (localHotSpot.y1 + yMinLimitPercents > localHotSpot.y2)
                    localHotSpot.y1 = localHotSpot.y2 - yMinLimitPercents;
                break;
            }
            case 'y2': {
                if (localHotSpot.y2 > 100)
                    localHotSpot.y2 = 100;

                if (localHotSpot.y2 - yMinLimitPercents < localHotSpot.y1)
                    localHotSpot.y2 = localHotSpot.y1 + yMinLimitPercents;
                break;
            }
        }

        zoomUtils.currentCroppingHotspot = localHotSpot;

        if (zoomUtils.updateTransformTool)
            zoomUtils.updateTransformTool();
    },
    getAlertTopPosition() {
        var value = 0;

        switch (this.state.currentAlert) {
            case 'x1': {
                value = -2;
                break;
            }
            case 'x2': {
                value = 40;
                break;
            }
            case 'y1': {
                value = 83;
                break;
            }
            case 'y2': {
                value = 125;
                break;
            }
        }

        return value;
    },
    getRealShapeSize(shapeModel) {
        var newShape;

        if (shapeModel.hotSpot != undefined && shapeModel.hotSpot != '') {
            var realWidth = shapeModel.width * 100 / (shapeModel.hotSpot.x2 - shapeModel.hotSpot.x1);
            var realHeight = shapeModel.height * 100 / (shapeModel.hotSpot.y2 - shapeModel.hotSpot.y1);
            var x1 = realWidth * shapeModel.hotSpot.x1 / 100;
            var y1 = realHeight * shapeModel.hotSpot.y1 / 100;
            newShape = {};

            newShape.width = realWidth;
            newShape.height = realHeight;
            newShape.x = shapeModel.x - x1;
            newShape.y = shapeModel.y - y1;
        } else
            newShape = shapeModel;

        return newShape;
    },
    getAlertRange() {
        const minSize = 30;
        var realShape = this.getRealShapeSize(zoomUtils.croppingTarget);
        var localHotSpot = {x1: zoomUtils.currentCroppingHotspot.x1, x2: zoomUtils.currentCroppingHotspot.x2, y1: zoomUtils.currentCroppingHotspot.y1, y2: zoomUtils.currentCroppingHotspot.y2};
        var xMinLimitPercents = Math.ceil(minSize * 100 / realShape.width);
        var yMinLimitPercents = Math.ceil(minSize * 100 / realShape.height);
        var range = '';

        switch (this.state.currentAlert) {
            case 'x1': {
                range = '0 - ' + Math.floor(localHotSpot.x2 - xMinLimitPercents);
                break;
            }
            case 'x2': {
                range = '' + Math.ceil(localHotSpot.x1 + xMinLimitPercents) + ' - 100';
                break;
            }
            case 'y1': {
                range = '0 - ' + Math.floor(localHotSpot.y2 - yMinLimitPercents);
                break;
            }
            case 'y2': {
                range = '' + Math.ceil(localHotSpot.y1 + yMinLimitPercents) + ' - 100';
                break;
            }
        }

        return range;
    },
    shouldComponentUpdate(newProps, nextState) {
        if (this.props.windowHeight != newProps.windowHeight || this.props.accordionWidth != newProps.accordionWidth || this.props.showCroppingMenu != newProps.showCroppingMenu || this.state.currentAlert != nextState.currentAlert)
            return true;
        else
            return false;
    },
    render() {
        if (this.props.showCroppingMenu == false)
            return (<div/>);

        const menuStyle = {
            position: 'absolute',
            top: apiServiceUtils.getNoInternetConnectionAlertHeight(),
            right: 0,
            width: this.props.accordionWidth,
            height: this.props.windowHeight,
            overflowX: 'hidden',
            overflowY: 'hidden',
            backgroundColor: 'white',
            zIndex: 20000
        };

        const buttonsHolderStyle = {
            position: 'absolute',
            top: properties.CLIPART_BUTTON_HEIGHT
        };

        const smallTextStyle = {
            fontSize: '12px',
            marginTop: '15px',
            marginBottom: '-5px'
        };

        const buttonWrapperStyle = {
            display: 'flex',
            flexWrap: 'wrap',
            marginTop: '10px',
            justifyContent: 'space-between'
        };

        var hotSpot = this.getHotSpot();

        const gap = 10;
        const bottomStyle = {
            position: 'absolute',
            top: 200,
            marginLeft: gap,
            marginRight: gap
        };

        const alertHeight = 30;
        const fillOutFieldViewWidth = menuStyle.width - 2 * gap;
        var fillOutFieldViewStyle = {
            position: 'absolute',
            background: '#434343',
            width: fillOutFieldViewWidth,
            height: alertHeight,
            top: this.getAlertTopPosition(),
            left: 0,
            borderRadius: 5,
            zIndex: 99999,
            pointerEvents: 'none'
        };

        const stemStyle = {
            position: 'absolute',
            borderWidth: 10,
            borderStyle: 'solid',
            borderBottomColor: 'transparent',
            borderTopColor: '#434343',
            borderLeftColor: 'transparent',
            borderRightColor: 'transparent',
            top: alertHeight,
            left: fillOutFieldViewWidth - 50
        };

        const captionStyle = {
            position: 'absolute',
            color: 'white',
            wordWrap: 'break-word',
            textAlign: 'center',
            fontSize: 12,
            left: 5,
            top: 8,
            width: fillOutFieldViewWidth - 10
        };

        var fillOutFieldView;
        var isFocus = this.state.currentAlert != 'none';

        if (isFocus) {
            var alertText = locales.getCaption('cropingAlertMessage', 'other') + ' ' + this.getAlertRange();

            fillOutFieldView =
                <div style={fillOutFieldViewStyle} role='alert'>
                    <div style={stemStyle}></div>
                    <div style={captionStyle}>
                        {alertText}
                    </div>
                </div>;
        }

        return (
            <div style={menuStyle} id='croppingMenu'>
                <Title accordionWidth={this.props.accordionWidth}/>

                <div style={buttonsHolderStyle}>
                    <Button accordionWidth={this.props.accordionWidth} index={0} dispatch={this.props.dispatch} text={locales.getCaption('SetCropping')}/>
                    <Button accordionWidth={this.props.accordionWidth} index={1} dispatch={this.props.dispatch} text={locales.getCaption('ResetCropping')}/>
                    <Button accordionWidth={this.props.accordionWidth} index={2} dispatch={this.props.dispatch} text={locales.getCaption('Cancel', 'save')}/>
                </div>

                <div style={bottomStyle}>
                    <h3 style={smallTextStyle}>{locales.getCaption('Crop', 'sizePosMenu')}</h3>

                    {fillOutFieldView}

                    <div style={buttonWrapperStyle}>
                        <MenuInput isInt={true} labelText={locales.getCaption('CropLeft', 'sizePosMenu') + ' (%)'} value={hotSpot.x1} property={'x1'} onChangeHandler={this.changeCrop} onFocusHandler={this.onFocusHandler} onBlurHandler={this.onBlurHandler}/>
                        <MenuInput isInt={true} labelText={locales.getCaption('CropRight', 'sizePosMenu') + ' (%)'} value={hotSpot.x2} property={'x2'} onChangeHandler={this.changeCrop} onFocusHandler={this.onFocusHandler} onBlurHandler={this.onBlurHandler}/>
                        <MenuInput isInt={true} labelText={locales.getCaption('CropTop', 'sizePosMenu') + ' (%)'} value={hotSpot.y1} property={'y1'} onChangeHandler={this.changeCrop} onFocusHandler={this.onFocusHandler} onBlurHandler={this.onBlurHandler}/>
                        <MenuInput isInt={true} labelText={locales.getCaption('CropBottom', 'sizePosMenu') + ' (%)'} value={hotSpot.y2} property={'y2'} onChangeHandler={this.changeCrop} onFocusHandler={this.onFocusHandler} onBlurHandler={this.onBlurHandler}/>
                    </div>
                </div>
            </div>
        );
    }
});

function mapStateToProps() {
    const state = storeManager.getState();
    var showCroppingMenu = state.menu.showCroppingMenu;
    var refreshShapePosition = state.menu.refreshShapePosition;

    if (showCroppingMenu == undefined)
        showCroppingMenu = false;

    return {
        showCroppingMenu,
        refreshShapePosition
    };
}

export const CroppingMenu = connect(mapStateToProps)(CroppingMenuContent);


/** WEBPACK FOOTER **
 ** ./src/components/menus/CroppingMenu.js
 **/